// =====================================================================================
// FILE: src/components/ui/Confetti.jsx
// Confetti celebration animation
// =====================================================================================
import React, { useEffect, useState } from "react";

const CONFETTI_COLORS = [
  "#2DD4BF", // Teal (primary)
  "#FFD700", // Gold
  "#FF6B6B", // Coral
  "#4ECDC4", // Turquoise
  "#FF8C42", // Orange
  "#A855F7", // Purple
  "#22C55E", // Green
];

function ConfettiPiece({ delay, left }) {
  const color = CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)];
  const size = 8 + Math.random() * 8;
  const duration = 2 + Math.random() * 2;
  const rotation = Math.random() * 360;
  
  return (
    <div
      style={{
        position: "fixed",
        top: -20,
        left: `${left}%`,
        width: size,
        height: size * 0.6,
        background: color,
        borderRadius: 2,
        transform: `rotate(${rotation}deg)`,
        animation: `confetti-fall ${duration}s ease-out ${delay}s forwards`,
        zIndex: 10000,
        pointerEvents: "none",
      }}
    />
  );
}

export default function Confetti({ trigger }) {
  const [pieces, setPieces] = useState([]);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (trigger) {
      // Generate confetti pieces
      const newPieces = [];
      for (let i = 0; i < 80; i++) {
        newPieces.push({
          id: i,
          delay: Math.random() * 0.5,
          left: Math.random() * 100,
        });
      }
      setPieces(newPieces);
      setShow(true);

      // Clean up after animation
      const timer = setTimeout(() => {
        setShow(false);
        setPieces([]);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [trigger]);

  if (!show) return null;

  return (
    <>
      <style>{`
        @keyframes confetti-fall {
          0% {
            transform: translateY(0) rotate(0deg);
            opacity: 1;
          }
          100% {
            transform: translateY(100vh) rotate(720deg);
            opacity: 0;
          }
        }
      `}</style>
      {pieces.map((piece) => (
        <ConfettiPiece key={piece.id} delay={piece.delay} left={piece.left} />
      ))}
    </>
  );
}

// Hook to detect when all items are approved
export function useConfettiTrigger(items) {
  const [hasTriggered, setHasTriggered] = useState(false);
  const [trigger, setTrigger] = useState(0);

  useEffect(() => {
    if (!items || items.length === 0) return;

    const allApproved = items.every(item => 
      item.contentStatus?.toLowerCase().includes("approved by lumen8")
    );

    // Only trigger once when transitioning to all approved
    if (allApproved && !hasTriggered && items.length > 0) {
      setTrigger(prev => prev + 1);
      setHasTriggered(true);
    }

    // Reset if items change and not all approved
    if (!allApproved) {
      setHasTriggered(false);
    }
  }, [items, hasTriggered]);

  return trigger;
}
